<h1 mat-dialog-title class="fw-bolder fs-5">Redirecting</h1>
<div mat-dialog-content>
    <p class="dialog-message pt-5"> Your login session has expired. Redirecting to the login page... </p>
</div>